import { useRouter } from "next/router";
import { useRef } from "react";
import { IconButton } from "@/components/Button";
import { GlobalDollarColoredIcon } from "@/components/Icon";
import cx from "classnames";
import { useManageNavigation, useResponsive } from "@/hooks";
import styles from "./Header.module.scss";

const RewardIconButton: React.FC<{ className?: string }> = ({ className }) => {
  const router = useRouter();
  const { isAllowedToNavigate } = useManageNavigation();
  const { isMobile } = useResponsive();
  const buttonRef = useRef<HTMLButtonElement>(null);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    const button = buttonRef.current;
    if (button && button === e.currentTarget) {
      const rect = button.getBoundingClientRect();
      const size = Math.max(rect.width, rect.height);
      const x = e.clientX - rect.left - size / 2;
      const y = e.clientY - rect.top - size / 2;

      const ripple = document.createElement("span");
      ripple.style.cssText = `
        position: absolute;
        width: ${size}px;
        height: ${size}px;
        left: ${x}px;
        top: ${y}px;
        background: rgba(255, 255, 255, 0.3);
        border-radius: 50%;
        transform: scale(0);
        animation: ripple 0.6s ease-out;
        pointer-events: none;
        z-index: 1000;
      `;

      button.appendChild(ripple);
      button.classList.add(styles.buttonActive);

      setTimeout(() => {
        if (ripple.parentNode) {
          ripple.remove();
        }
        button.classList.remove(styles.buttonActive);
      }, 300);
    }

    setTimeout(() => {
      router.push("/rewards?tab=reward-center");
    }, 300);
  };

  return isAllowedToNavigate && isMobile ? (
    <IconButton
      ref={buttonRef}
      onClick={handleClick}
      className={cx(className, styles.chatButtonFocus)}
    >
      <GlobalDollarColoredIcon />
    </IconButton>
  ) : null;
};

export default RewardIconButton;
